import React from "react";
import classNames from "classnames";
import { currencyFormatter } from "@common/helpers/currency";
import { numberFormatter } from "@common/helpers/number";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BaseCellProps } from ".";
import styles from "./CalculatedAmountCell.module.scss";

interface CalculatedAmountCellProps extends BaseCellProps {
    quantityField?: string;
    rateField?: string;
}

export const CalculatedAmountCell: React.FC<CalculatedAmountCellProps> = ({
    value,
    row,
    quantityField = "quantity",
    rateField = "unitAmount",
}) => {
    if (typeof value !== "number") {
        return null;
    }

    const quantityValue = row[quantityField];
    const rateValue = row[rateField];
    const formattedAmount = currencyFormatter.format(value);

    if (typeof quantityValue !== "number" || typeof rateValue !== "number") {
        return <span>{formattedAmount}</span>;
    }

    return (
        <Tooltip
            side="top"
            content={
                <div className={styles.tooltip}>
                    <div className={styles.tooltipHeading}>
                        Calculated field
                    </div>
                    <div className={styles.tooltipRow}>
                        <span className={styles.tooltipLabel}>Quantity</span>
                        <span className={styles.tooltipValue}>
                            {numberFormatter.format(quantityValue)}
                        </span>
                    </div>
                    <div className={styles.tooltipRow}>
                        <span className={styles.tooltipLabel}>Rate</span>
                        <span className={styles.tooltipValue}>
                            <span className={styles.tooltipOperator}>x</span>
                            {currencyFormatter.format(rateValue)}
                        </span>
                    </div>
                    <div
                        className={classNames(
                            styles.tooltipRow,
                            styles.tooltipRowTotal,
                        )}
                    >
                        <span className={styles.tooltipLabel}>Amount</span>
                        <span className={styles.tooltipValue}>
                            {formattedAmount}
                        </span>
                    </div>
                </div>
            }
        >
            <span className={styles.trigger}>{formattedAmount}</span>
        </Tooltip>
    );
};
